module.exports = __webpack_public_path__ + "img/exchange-1-zh.a878334d.png";